export const widgetTextFilter = {
  code: "widget-text-filter",
  type: "html",
  label: "文本筛选",
  icon: "icon-shaixuan",
  options: {
    // 配置
    setup: [
      {
        type: "el-input-number",
        label: "字体大小",
        name: "fontSize",
        required: false,
        placeholder: "",
        value: "14",
      },
    ],
    // 数据
    data: [{
      type: "el-input-text",
      label: "默认值",
      name: "text",
      placeholder: "请输入默认值",
      required: false,
      value: "",
    }, {
      type: "choose-fields",
      label: "筛选维度",
      name: "dynamicData",
      required: false,
      placeholder: "",
      value: [],
    }],
    // 坐标
    position: [
      {
        type: "el-input-number",
        label: "左边距",
        name: "left",
        required: false,
        placeholder: "",
        value: 0,
      },
      {
        type: "el-input-number",
        label: "上边距",
        name: "top",
        required: false,
        placeholder: "",
        value: 0,
      },
      {
        type: "el-input-number",
        label: "宽度",
        name: "width",
        required: false,
        placeholder: "该容器在1920px大屏中的宽度",
        value: 160,
      },
      {
        type: "el-input-number",
        label: "高度",
        name: "height",
        required: false,
        placeholder: "该容器在1080px大屏中的高度",
        value: 32,
      },
    ],
  },
};
